import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function useLanguageNavigation() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  
  const navigateWithLang = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Get current language from URL path first
    let currentLang = null;
    const pathSegments = location.pathname.split('/');
    if (pathSegments.length > 1 && pathSegments[1] && pathSegments[1].length === 2) {
      // Check if the first segment looks like a language code
      currentLang = pathSegments[1];
    }
    
    // If no language in URL, try to get from i18n or localStorage
    if (!currentLang) {
      // Try to get from current i18n language first
      if (i18n.language && i18n.language !== 'undefined') {
        currentLang = i18n.language.split('-')[0]; // Take only the language part (e.g., 'he' from 'he-IL')
      } else {
        // Try to get from i18n localStorage
        const i18nLang = localStorage.getItem('i18nextLng');
        if (i18nLang && i18nLang !== 'undefined') {
          currentLang = i18nLang.split('-')[0];
        } else {
          // Fallback to localStorage or default
          currentLang = localStorage.getItem('preferredLanguage') || 'en';
        }
      }
    }
    

    
    navigate(`/${currentLang}/${cleanPath}`);
  };
  
  // Get current language for return value
  const getCurrentLang = () => {
    const pathSegments = location.pathname.split('/');
    if (pathSegments.length > 1 && pathSegments[1] && pathSegments[1].length === 2) {
      return pathSegments[1];
    }
    return lang || i18n.language?.split('-')[0] || localStorage.getItem('i18nextLng')?.split('-')[0] || localStorage.getItem('preferredLanguage') || 'en';
  };
  
  return { navigateWithLang, currentLang: getCurrentLang() };
} 